
import {FC, useState, useMemo} from "react";

import {DocumentPlusIcon, ChevronUpIcon} from "@heroicons/react/24/outline";
import Loader from "../../components/layouts/loader";
import {withRoles, wrapClick, useUrlState} from "../../utils";
import CreateMeterContractorMaterialStoreContainer from "./cards/create-material-store";
import { Disclosure, Transition } from "@headlessui/react";

type Props = {
  data: any,
  loading: boolean,
  refetch: () => void,
}

const SettingsMaterialStoresContainer: FC<Props> = ({ data, loading, refetch }) => {

  const [modal, setModal] = useUrlState("modal");
  const [openStore, setOpenStore] = useState<any>(null)

  const stores = useMemo(() => data?.meterContractor?.materialStores || [], [data])

  if(loading){
    return (
      <div className="flex-1 w-full min-h-full py-6">
        <Loader text={"Loading Material Stores..."} />
      </div>
    )
  }


  // @ts-ignore
  return (
    <div className="overflow-hidden shadow sm:rounded-md">
      <div className="bg-white px-4 py-5 sm:p-6">
        <div className={"flex flex-col"}>
          {
            !Boolean(stores?.length) ? (
              <>
                <div className={"w-full py-16 bg-gray-50 rounded text-gray-400 border-gray-200 border-2 border-dashed grid place-items-center"}>
                  No Facilities Found.
                </div>
              </>
            ) : (
              <>
                <div className={"flex flex-col gap-1"}>
                  {stores.map(
                    (store: any, idx: number) => (
                      <Disclosure
                        defaultOpen={store.ghanaPostAddress === openStore?.ghanaPostAddress}
                        key={idx}
                      >
                        <Disclosure.Button
                          as="div"
                          onClick={() => setOpenStore(store)}
                          className="relative cursor-pointer flex justify-between gap-x-6 px-4 py-5 bg-gray-50 hover:bg-gray-100 duration-150 sm:px-6 lg:px-8"
                        >
                          <div className="flex min-w-0 gap-x-4">
                            <div className="min-w-0 flex-auto">
                              <p className="text-sm font-normal leading-6 text-gray-900">
                                <span>
                                  <span className="absolute inset-x-0 -top-px bottom-0" />
                                  {store.name}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div>
                            <ChevronUpIcon
                              className={`${
                                openStore?.ghanaPostAddress !== store!.ghanaPostAddress
                                  ? "rotate-180 transform"
                                  : ""
                              } h-5 w-5 flex-none text-gray-400`}
                            />
                          </div>
                        </Disclosure.Button>
                        <Transition
                          show={openStore?.ghanaPostAddress === store!.ghanaPostAddress}
                          enter="transition-all ease-in-out duration-[600ms] "
                          enterFrom="transform  max-h-0"
                          enterTo="transform  max-h-[1000px]"
                          leave="transition-all ease-in-out duration-[400ms]"
                          leaveFrom="transform  max-h-[1000px]"
                          leaveTo="transform  max-h-0"
                        >
                          <Disclosure.Panel static className="space-y-1 overflow-hidden">
                            <div
                              className="space-y-1 p-2"
                              role="group"
                            >
                              <div className="border-2 border-gray-200 border-dashed bg-gray-50 grid grid-cols-3 gap-6 p-6 rounded">
                                <div className={"col-span-2"}>
                                  <span className="block text-sm font-light text-gray-700">
                                    Residential Address
                                  </span>
                                  <div className="mt-1 block w-full sm:text-sm">
                                    {store?.address || "N/A"}
                                  </div>
                                </div>
                                <div className={"col-span-1"}>
                                  <span className="block text-sm font-light text-gray-700">
                                    GhanaPost Address
                                  </span>
                                  <div className="mt-1 block w-full sm:text-sm">
                                    {store?.ghanaPostAddress || "N/A"}
                                  </div>
                                </div>
                                <div className={"col-span-2"}>
                                  <span className="block text-sm font-light text-gray-700">
                                    Contact Person
                                  </span>
                                  <div className="mt-1 block w-full sm:text-sm">
                                    {store?.contactPerson.fullName || "N/A"}
                                  </div>
                                </div>
                                <div className={"col-span-1"}>
                                  <span className="block text-sm font-light text-gray-700">
                                    Phone Number
                                  </span>
                                  <div className="mt-1 block w-full sm:text-sm">
                                    {store?.contactPerson.phoneNumber || "N/A"}
                                  </div>
                                </div>
                                <div className={"col-span-1"}>
                                  <span className="block text-sm font-light text-gray-700">
                                    Email Address
                                  </span>
                                  <div className="mt-1 block w-full sm:text-sm">
                                    {store?.contactPerson.emailAddress || "N/A"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Disclosure.Panel>
                        </Transition>
                      </Disclosure>
                    )
                  )}
                </div>
              </>
            )
          }
        </div>
        <div className={"flex-1 flex justify-end mt-4"}>
          {withRoles(["Super"])(
            <button
              type="button"
              onClick={wrapClick(() => setModal("create-material-store"))}
              className="ml-3 inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm leading-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              <DocumentPlusIcon
                className="-ml-0.5 mr-2 h-4 w-4"
                aria-hidden="true"
              />
              Add Material Store
            </button>
          )}
        </div>
      </div>
      <CreateMeterContractorMaterialStoreContainer
        open={modal === "create-material-store"}
        setOpen={(val: boolean) => setModal(val ? "create-material-store" : undefined)}
        refetch={refetch}
      />
    </div>
  );



};

export default SettingsMaterialStoresContainer;